import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/rewards/tag_sold_out.png';
var _hoisted_1 = {
  class: "list-content"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  key: 0,
  class: "mask"
};
var _hoisted_4 = {
  key: 1,
  class: "tag",
  src: _imports_0,
  alt: ""
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "redeem-title"
};
var _hoisted_7 = {
  class: "redeem-desc"
};
var _hoisted_8 = {
  class: "redeem-points"
};
var _hoisted_9 = {
  class: "points"
};
import PoweredBy from "@/components/PoweredBy.vue";
import { ref } from "vue";
import { getPointsProduct } from "@/api/reward";
import CouponDetailPopup from "./CouponDetailPopup.vue";
import EmptyListPlaceholder from "../EmptyListPlaceholder.vue";
import { ossStyleProcess } from "@/utils/tools";
export default {
  __name: 'RewardRedeemList',
  emits: ["success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var loading = ref(false);
    var finished = ref(false);
    var showDetail = ref(false);
    var pageNum = ref(1);
    var pageSize = ref(20);
    var redeemList = ref([]);
    var curItem = ref(null);
    var emit = __emit;
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getPointsProduct({
                page_num: pageNum.value,
                page_size: pageSize.value
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = res.data.items || [];
                if (data.length > 0) {
                  redeemList.value = redeemList.value.concat(data);
                  pageNum.value += 1;
                } else {
                  finished.value = true;
                }
              } else {
                finished.value = true;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var genTitle = function genTitle(item) {
      return item.title;
    };
    var onBuySuccess = function onBuySuccess() {
      redeemList.value = [];
      finished.value = false;
      pageNum.value = 1;
      emit("success");
    };
    var toDetail = function toDetail(item) {
      var _item$product_info;
      if (item.shelf_stock === 0) return;
      curItem.value = {
        coupon_info: (_item$product_info = item.product_info) === null || _item$product_info === void 0 ? void 0 : _item$product_info.coupon,
        points_price: item.points_price,
        id: item.id,
        picture: item.picture,
        limit_repurchase: item.limit_repurchase,
        title: item.title
      };
      showDetail.value = true;
    };
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createBlock(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
          return loading.value = $event;
        }),
        class: "reward-redeem-list",
        finished: finished.value,
        "loading-text": _ctx.$t('loading'),
        onLoad: fetchData
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [!loading.value && redeemList.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
            key: 0,
            text: _ctx.$t('noProductsYet'),
            class: "empty"
          }, null, 8, ["text"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(redeemList.value, function (item) {
            var _item$product_info2;
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["redeem", {
                'van-haptics-feedback': item.shelf_stock !== 0
              }]),
              onClick: function onClick($event) {
                return toDetail(item);
              }
            }, [item.shelf_stock === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true), item.shelf_stock === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("img", {
              class: "redeem-img",
              alt: "",
              src: _unref(ossStyleProcess)(item.picture || 'https://res.disoo.com/store/ca01be2f-009e-4fdb-86a3-515772ccca7b.png', 'type_3')
            }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(genTitle(item)), 1), _createElementVNode("div", _hoisted_7, _toDisplayString((_item$product_info2 = item.product_info) === null || _item$product_info2 === void 0 || (_item$product_info2 = _item$product_info2.coupon) === null || _item$product_info2 === void 0 ? void 0 : _item$product_info2.description), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.points_price), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("pointSmall")), 1)])], 10, _hoisted_2);
          }), 128))]), finished.value ? (_openBlock(), _createBlock(PoweredBy, {
            key: 0,
            "is-list": true
          })) : _createCommentVNode("", true), _createVNode(CouponDetailPopup, {
            show: showDetail.value,
            "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
              return showDetail.value = $event;
            }),
            coupon: curItem.value,
            from: "Rewards",
            type: "redeem",
            onSuccess: onBuySuccess
          }, null, 8, ["show", "coupon"])];
        }),
        _: 1
      }, 8, ["loading", "finished", "loading-text"]);
    };
  }
};